import { DEBUG } from '@app/constants/SEARCH.ts';
import type { ScriptTuple } from '@features/third-party-scripts/types/ScriptTuple.ts';

// todo: replace with IaC
export const UAT_SCRIPTS = (domainData: SNDomainData): (false | ScriptTuple)[] => [
  new URLSearchParams(location.search).has(DEBUG) && {
    position: 'append',
    target: 'head',
    scriptMarkup:
      '        <script\n' +
      '          crossOrigin="anonymous"\n' +
      '          src="//unpkg.com/react-scan/dist/auto.global.js"\n' +
      '        ></script>',
  },
  Boolean(domainData.venueName) && {
    position: 'append',
    target: 'head',
    scriptMarkup: `
    <script type="text/javascript">
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "v29gpe966m");
    </script>
    `,
  },
  domainData.venueName === 'sn' && {
    position: 'append',
    target: 'head',
    scriptMarkup: `
      <!-- Google Tag Manager -->
      <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-PQ8575S9');</script>
      <!-- End Google Tag Manager -->
    `,
  },
  domainData.venueName === 'sn' && {
    position: 'prepend',
    target: 'body',
    scriptMarkup: `
      <!-- Google Tag Manager (noscript) -->
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PQ8575S9"
      height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
      <!-- End Google Tag Manager (noscript) -->
    `,
  },

  domainData.venueName === 'cgg' && {
    position: 'append',
    target: 'head',
    scriptMarkup: `
      <!-- Google Tag Manager -->
      <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-WQ6T7H33');</script>
      <!-- End Google Tag Manager -->
    `,
  },
  domainData.venueName === 'cgg' && {
    position: 'prepend',
    target: 'body',
    scriptMarkup: `
      <!-- Google Tag Manager (noscript) -->
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WQ6T7H33"
      height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
      <!-- End Google Tag Manager (noscript) -->
    `,
  },
  domainData.venueName === 'stt' && {
    position: 'append',
    target: 'head',
    scriptMarkup: `
      <!-- Google Tag Manager -->
      <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-5MGS32GX');</script>
      <!-- End Google Tag Manager -->
    `,
  },
  domainData.venueName === 'stt' && {
    position: 'prepend',
    target: 'body',
    scriptMarkup: `
      <!-- Google Tag Manager (noscript) -->
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5MGS32GX"
      height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
      <!-- End Google Tag Manager (noscript) -->
    `,
  },
];
